import React from "react";
import Chart from "react-apexcharts";

import moment from "moment";


const StatsChart = ({ data, groupBy }) => {

  if (!data || !data.data) {
    return null;
  }

  const formatCategory = (value) => {
    if (groupBy === "day") {
      return moment(value).format("DD.MM.YYYY");
    }

    if (groupBy === "week") {
      const match = value.match(/^(\d{4})W(\d{2})$/);

      if (!match) {
        return value;
      }

      const year = Number(match[1]);
      const week = Number(match[2]);

      return moment()
        .isoWeekYear(year)
        .isoWeek(week)
        .startOf("isoWeek")
        .format("DD.MM.YYYY");
    }

    if (groupBy === "month") {
      return moment(value, "YYYY-MM").format("MM.YYYY");
    }

    return value;
  };


  const dates = Object.keys(data.data).sort();
  const categories = dates.map(formatCategory);

  const income = dates.map((date) => {
    return data.data[date].income || 0;
  });

  const options = {
    chart: {
      type: "line",
      height: 350,
      toolbar: {
          show: false
      }
    },

    colors: [
      "#FF9800",  // Загрузки
      "#9C27B0",  // Показы
      "#c01453",  // Клики
      // "#2196F3",  // Доход
      "#4CAF50",  // Прибыль
    ],

    stroke: {
      curve: "smooth",
      width: 3
    },

    dataLabels: {
      enabled: false
    },

    xaxis: {
      categories
    },

    yaxis: {
      labels: {
        formatter: (value) => {
          return value.toLocaleString("ru-RU");
        }
      }
    },

    tooltip: {
      y: {
        formatter: (value, { seriesIndex, w }) => {
          if (value == null) {
            return "";
          }

          const seriesName = w.config.series[seriesIndex]?.name;
          const formattedValue = Number(value).toLocaleString("ru-RU");

          if (seriesName === "Доход" || seriesName === "Прибыль") {
            return `${formattedValue} ₽`;
          }

          return formattedValue;
        }
      }
    }

  };

  const series = [
    {
      name: "Загрузки",
      data: dates.map((date) => data.data[date].visits || 0)
    },
    {
      name: "Показы",
      data: dates.map((date) => data.data[date].views || 0)
    },
    {
      name: "Клики",
      data: dates.map((date) => data.data[date].clicks || 0)
    },
    // {
    //   name: "Доход",
    //   data: dates.map((date) => data.data[date].income || 0)
    // },
    {
      name: "Прибыль",
      data: dates.map((date) => data.data[date].profit || 0)
    }
  ];

  const formatWeek = (week) => {
    const match = week.match(/^(\d{4})W(\d{2})$/);

    if (!match) {
      return week;
    }

    const year = Number(match[1]);
    const weekNumber = Number(match[2]);

    const date = moment()
      .isoWeekYear(year)
      .isoWeek(weekNumber)
      .startOf("isoWeek");

    return date.format("DD.MM.YYYY");
  };

  return (
    <div className="chart-here">
      <Chart
        options={options}
        series={series}
        type="line"
        height={350}
      />
    </div>
  );
};

export default StatsChart;